export const ru = {
    placeholder: 'Введите минус-фразу'
};
